import React from "react";
import Label from "./Label";
import Select from "./Select";
const SelectGroup = (props) => {
  const { isRequired, label, labelSize, options, placeholder, ...selectProps } = props;
  return /* @__PURE__ */ React.createElement("div", { className: "form-input-group" }, /* @__PURE__ */ React.createElement(Label, { isRequired, labelSize }, label), /* @__PURE__ */ React.createElement(Select, { options, placeholder, ...selectProps }));
};
export default SelectGroup;
